/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MagnetAffinity {
  None = 'None',
  Dynamic = 'Dynamic',
  Static = 'Static',
  Any = 'Any'
}
